import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};

const LINE = { hidden: { y: "110%" }, show: { y: "0%" } };

export const MaskLines = ({ lines, className = "", delay = 0.2, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block" variants={LINE} transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, light = false }) => (
  <span className={`inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-[#F4DED3]" : "text-[#9E4429]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#F4DED3]" : "bg-[#9E4429]"}`} />
    {children}
  </span>
);
